import { z } from 'zod'

export const CreateContractSchema = z.object({
  ordererCustomerId: z.number().int().positive({ message: 'Wybierz klienta' }),
  configurationCode: z.string().min(1),
  assigneeUserId: z.number().int().positive().nullable().optional(),
  ownerTeamId: z.number().int().positive().nullable().optional(),
  // totalAmount + currency są opcjonalne - "wartość umowy" to realnie dynamic
  // field w extras (edytowany na detalu w sekcji formularza). Backend default PLN.
  totalAmount: z.number().nonnegative().nullable().optional(),
  currency: z.string().length(3).optional(),
  hasCredit: z.boolean(),
  extras: z.record(z.string(), z.unknown()).optional(),
  salesPersonId: z.number().int().positive().nullable().optional(),
})

export type CreateContractInput = z.infer<typeof CreateContractSchema>
